import {baseApi} from "../api/axios";
import {useNavigate, useParams} from "react-router-dom";
import {useEffect, useState} from "react";
import {useAuthStore} from "../store/user-store";
import {toast} from "react-toastify";
import LoadingComponent from "../components/Loading/LoadingComponent";

export default function BankDetailesPage(){

const params=useParams()
    const redirect = useNavigate()
    const [loading,setLoading]=useState(false)
    const [bank,setBank]=useState(null)
    const [loadingSubmit, setLoadingSubmit] = useState(false)
    const [errorImage, setErrorImage] = useState('')
    const [errorAmount, setErrorAmount] = useState('')
    const [errorTransId, setErrorTransId] = useState('')
    const [amount, setAmount] = useState(0)
    const [image, setImage] = useState(0)
    const [info, setInfo] = useState('')
    const [transId, setTransId] = useState('')
    const [imagePreview, setImagePreview] = useState(null);
    const authStore = useAuthStore();
    const onSubmit = async () => {
        setErrorImage('')
        setErrorAmount('')
        setErrorTransId('')
        setLoadingSubmit(true)
        if (!image) {
            setErrorImage('يرجى تحديد صورة الإشعار')
            setLoadingSubmit(false)
            return;
        }

        if (parseFloat(amount) <= 0) {
            setErrorAmount('يرجى إدخال القيمة')
            setLoadingSubmit(false)
            return;
        }
        if(bank?.available_check && transId==''){
            setErrorTransId('أدخل رقم الحوالة')
            return
        }

        const formData = new FormData();
        formData.append('amount', amount);
        formData.append('img', image);
        formData.append('bank_id', bank?.id);
        formData.append('trans_id',transId);
        formData.append('info', info);
        try {
            var response = await baseApi.post('/charges', formData);
            toast.success('تم إرسال الطلب بنجاح')
            redirect('/charges')
        } catch (e) {
        }
        setLoadingSubmit(false)
    }
    const handleImageChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            const reader = new FileReader();
            reader.onloadend = () => {
                setImage(file);
                setImagePreview(reader.result);
            };
            reader.readAsDataURL(file);
        } else {
            setImage(null);
            setImagePreview(null);
        }
    }

const getBank=async  ()=>{
        console.log(`TEST ${params.id}`)
    setLoading(true)
    try {
        var res = await baseApi(`/banks/${params.id}`);

        if (res.data?.bank != null) {
            setBank(res.data?.bank)

        }
        console.log(res.data);
    } catch (e) {

    }
    setLoading(false)
    }
    useEffect(()=>{
        getBank()
    },[])
    if(loading===true){
        return <div className={'d-flex justify-content-center'}>
            <LoadingComponent/>
        </div>
    }
    return (
       <div className={'container'}>
           <div className="row justify-content-center">
               <div className="col-md-8 py-2">

                   {bank?.id == null && loading===false ? <h3 className={'alert alert-warning'}>يرجى تحديد طريقة دفع</h3> : null}
                   {
                       bank?.id != null ? <div>
                               <h3 className={'text-white text-center'}>{bank?.name}</h3>
                               <p className={'text-black text-center bank-info bg-white p-2'}>{bank?.info}
                                   <br/>
                                   <span>رقم الحساب : </span>
                                   {bank?.iban!==''? <span><span className={'text-danger'}>{bank?.iban}</span> <i className="fa fa-copy fa-lg mx-2"
                                                                                                                  onClick={() => authStore.copyText(bank?.iban)}/></span>:null}
                                   {bank?.iban2!==''? <span><span className={'text-danger'}>{bank?.iban2}</span> <i className="fa fa-copy fa-lg mx-2"
                                                                                                                  onClick={() => authStore.copyText(bank?.iban2)}/></span>:null}

                               </p>


                               <div className="text-center m-auto">
                                   <div className="form-group">
                                       <label htmlFor="" className={'text-white'}>القيمة</label>
                                       <input type="text" onChange={(e) => setAmount(e.target.value)}
                                              className="input-form my-2  m-auto" placeholder={'القيمة'} autoComplete={'off'}
                                              value={amount}/>
                                       {errorAmount?.length > 0 ? <span className={'text-danger'}>{errorAmount}</span> : null}
                                   </div>

                                   <div className="form-group">
                                       <label htmlFor="" className={'text-white'}>صورة الإشعار</label>
                                       <input type="file" onChange={handleImageChange}
                                              className="input-form my-2  m-auto" placeholder={'صورة الإشعار'}
                                              autoComplete={'off'}/>
                                       {errorImage?.length > 0 ? <span className={'text-danger'}>{errorImage}</span> : null}
                                   </div>

                                   <div className="text-center m-auto">
                                       <div className="form-group">
                                           <label htmlFor="" className={'text-white'}>رقم الحوالة</label>
                                           <input type="text" onChange={(e) => setTransId(e.target.value)}
                                                  className="input-form my-2  m-auto" placeholder={'رقم الحوالة'} autoComplete={'off'}
                                                  value={transId} required={bank?.available_check}/>
                                           {errorAmount?.length > 0 ? <span className={'text-danger'}>{errorTransId}</span> : null}
                                       </div>
                                   </div>
                                  {/* {bank?.available_check!=true && (
                                       <div className="form-group">
                                           <label htmlFor="" className={'text-white'}>ملاحظات</label>
                                           <input type="text" onChange={(e) => setInfo(e.target.value)}
                                                  className="input-form my-2  m-auto" placeholder={'ملاحظات'}
                                                  autoComplete={'off'}/>

                                       </div>
                                   )}*/}

                                   {imagePreview && (
                                       <div className="image-preview mt-3">
                                           <img src={imagePreview} alt="Preview" style={{maxWidth: '100%'}}/>
                                       </div>
                                   )}
                               </div>
                               <div className={'text-center d-flex w-100 justify-content-center mt-3'}>
                               {!loadingSubmit ?
                                   <button onClick={onSubmit} className="btn d-block btn-sm submit-btn text-center ">إرسال الطلب</button> :
                                   <button className="btn d-block btn-sm submit-btn ">جاري المعالجة</button>}
                           </div>
                           </div>
                           : null
                   }
               </div>
           </div>

       </div>
    )
}